import React, { FC, memo } from 'react'

import { isDevMode } from '@sportworld/js-sdk/src/envs/envs'

import { useCommonTranslation } from '@/i18n/useCommonTranslation'
import { DescriptionQrProps } from '@/types/componentsPropsTypes'

import {
  Code,
  DescWrapper,
  Expires,
  TextElemMain,
  TextElem,
  TitleElem,
} from './styles'

const DescriptionQrRaw: FC<DescriptionQrProps> = ({
  code,
  link,
  title,
  mobileStyle = false,
  remainingTime,
  selfServiceType = false,
}) => {
  const { t } = useCommonTranslation()
  return (
    <DescWrapper $mobileStyle={mobileStyle} $selfServiceType={selfServiceType}>
      {title && <TitleElem>{title}</TitleElem>}
      <TextElemMain>
        {selfServiceType ? t('qrInstruction3') : t('qrInstruction1')}
      </TextElemMain>
      <TextElem>
        {t('qrInstruction3')}
        {isDevMode ? (
          <a href={`${link}?code=${code}`} target="_blank" rel="noreferrer">
            {link}
          </a>
        ) : (
          <span>{link}</span>
        )}
        {t('qrInstruction2')}
      </TextElem>
      <Code>{code}</Code>
      <Expires>
        {t('expiresIn')} {remainingTime}
      </Expires>
    </DescWrapper>
  )
}

export const DescriptionQr = memo(DescriptionQrRaw)
